import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import $ from 'jquery';

import ViceChancellorMessage from '../../components/ViceChancellorMessage';
import './Home.css';

window.jQuery = $;
window.$ = $;

const TRUNCATION_LENGTH = 1000;

/* ---------- Helper Functions ---------- */
const embedLinkInTruncatedDescription = (description, maxLength = TRUNCATION_LENGTH) => {
  if (!description) return 'No Description Available';
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const match = description.match(urlRegex);
  const url = match ? match[0] : null;
  const cleanedDescription = description.replace(urlRegex, '').trim();
  const truncatedText =
    cleanedDescription.length > maxLength
      ? cleanedDescription.substring(0, maxLength) + '...'
      : cleanedDescription;
  // For non-download items, if a URL is found, show only the "See more details" link
  if (url) {
    return `<span class="description-text">${truncatedText}</span><span class="description-link"> <a href="${url}" target="_blank" rel="noopener noreferrer" style="color: #007bff; text-decoration: none; font-weight:bold;">See more details</a></span>`;
  } else {
    return `<span class="description-text">${truncatedText}</span>`;
  }
};

const embedLinksWithDownloadOption = (description, maxLength = TRUNCATION_LENGTH) => {
  if (!description) return 'No Description Available';
  const domainRegex = /^https?:\/\/121\.52\.154\.120:3001\//i;
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const matches = description.match(urlRegex) || [];
  const cleanedDescription = description.replace(urlRegex, '').trim();
  const truncatedText =
    cleanedDescription.length > maxLength
      ? cleanedDescription.substring(0, maxLength) + '...'
      : cleanedDescription;
  // Create links for each URL found
  const linksHtml = matches
    .map((url) => {
      if (domainRegex.test(url)) {
        return `<a href="${url}" target="_blank" rel="noopener noreferrer" style="color: #007bff; text-decoration: none; font-weight:bold; display:inline; margin-left:4px;">Download</a>`;
      } else {
        return `<a href="${url}" target="_blank" rel="noopener noreferrer" style="color: #007bff; text-decoration: none; font-weight:bold; display:inline; margin-left:4px;">See more details</a>`;
      }
    })
    .join(' ');
  return `<span class="description-text">${truncatedText}</span><br/><span class="description-link">${linksHtml}</span>`;
};

/* 
   Single-rectangle SlingSlot:
   Renders exactly ONE rectangle for each category,
   auto-rotating items (if more than 1) every 5 seconds.
   The prop "useDownload" determines which helper function to use.
*/
const SlingSlot = ({ category, items, useDownload }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-rotate if more than one item
  useEffect(() => {
    if (items.length > 1) {
      const interval = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % items.length);
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [items]);

  // Current item to display
  const currentItem = items[currentIndex] || {};

  return (
    <div className="sling-slot">
      <div className="sling-slot-category">{category}</div>
      <div className="sling-rectangle">
        <div className="sling-rectangle-title">
          {currentItem.title || 'No Title'}
        </div>
        <div
          className="sling-rectangle-description"
          dangerouslySetInnerHTML={{
            __html: useDownload
              ? embedLinksWithDownloadOption(currentItem.description || '')
              : embedLinkInTruncatedDescription(currentItem.description || '')
          }}
        />
      </div>
    </div>
  );
};

function Home() {
  const [sliderImages, setSliderImages] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);

  const [admissions, setAdmissions] = useState([]);
  const [newsEvents, setNewsEvents] = useState([]);
  const [postgraduateUpdates, setPostgraduateUpdates] = useState([]);
  const [examinations, setExaminations] = useState([]);
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [tenderNotices, setTenderNotices] = useState([]);
  const [newsAndUpdates, setNewsAndUpdates] = useState([]);
  const [studentsConsultativeUpdates, setStudentsConsultativeUpdates] = useState([]);
  const [studentEvents, setStudentEvents] = useState([]);

  /* ---------- Data Fetching ---------- */
  useEffect(() => {
    const fetchNewsEvents = async () => {
      try {
        const response = await fetch('http://121.52.154.120:3001/api/news-events');
        const rawNewsEvents = await response.json();
        const formatted = rawNewsEvents.map((ne) => ne?.dataValues || ne);
        setNewsEvents(formatted.reverse());
      } catch (error) {
        console.error('Error fetching news events:', error.message);
      }
    };

    const fetchAdmissions = async () => {
      try {
        const response = await fetch('http://121.52.154.120:3001/api/admissions');
        const rawAdmissions = await response.json();
        const formatted = rawAdmissions.map((adm) => adm?.dataValues || adm);
        setAdmissions(formatted.reverse());
      } catch (error) {
        console.error('Error fetching admissions:', error.message);
      }
    };

    const fetchPostgraduateUpdates = async () => {
      try {
        const response = await axios.get('http://121.52.154.120:3001/api/updates/postgraduate');
        setPostgraduateUpdates(response.data.reverse());
      } catch (error) {
        console.error('Error fetching postgraduate:', error.message);
      }
    };

    const fetchExaminations = async () => {
      try {
        const response = await axios.get('http://121.52.154.120:3001/api/updates/examinations');
        setExaminations(response.data.reverse());
      } catch (error) {
        console.error('Error fetching exams:', error.message);
      }
    };

    const fetchUpcomingEvents = async () => {
      try {
        const response = await axios.get('http://121.52.154.120:3001/api/updates/upcoming-events');
        setUpcomingEvents(response.data.reverse());
      } catch (error) {
        console.error('Error fetching upcoming events:', error.message);
      }
    };

    const fetchTenderNotices = async () => {
      try {
        const response = await axios.get('http://121.52.154.120:3001/api/updates/tender-notices');
        setTenderNotices(response.data.reverse());
      } catch (error) {
        console.error('Error fetching Tender Notices:', error.message);
      }
    };

    const fetchNewsAndUpdates = async () => {
      try {
        const response = await axios.get('http://121.52.154.120:3001/api/updates/news-and-updates');
        setNewsAndUpdates(response.data.reverse());
      } catch (error) {
        console.error('Error fetching news/updates:', error.message);
      }
    };

    const fetchStudentsConsultativeUpdates = async () => {
      try {
        const response = await axios.get('http://121.52.154.120:3001/api/updates/students-consultative-bureau');
        if (response.data && response.data.success && Array.isArray(response.data.data)) {
          setStudentsConsultativeUpdates(response.data.data.reverse());
        } else {
          console.error('Unexpected structure:', response.data);
          setStudentsConsultativeUpdates([]);
        }
      } catch (error) {
        console.error('Error fetching consultative:', error.message);
        setStudentsConsultativeUpdates([]);
      }
    };

    const fetchStudentEvents = async () => {
      try {
        const response = await axios.get('http://121.52.154.120:3001/api/student-events');
        setStudentEvents(response.data.reverse());
      } catch (error) {
        console.error('Error fetching student events:', error.message);
      }
    };

    fetchNewsEvents();
    fetchAdmissions();
    fetchPostgraduateUpdates();
    fetchExaminations();
    fetchUpcomingEvents();
    fetchTenderNotices();
    fetchNewsAndUpdates();
    fetchStudentsConsultativeUpdates();
    fetchStudentEvents();
  }, []);

  /* ---------- Fetch Slider Images ---------- */
  useEffect(() => {
    const fetchSliderImages = async () => {
      try {
        const response = await axios.get('http://121.52.154.120:3001/api/slider-images');
        const formatted = response.data
          .map((img) => ({
            id: img?.id || Math.random(),
            imageUrl: img?.imageUrl || '/fallback-image.jpg',
            caption: img?.caption || 'No Caption Available',
            detail: img?.detail || 'No Details Available',
          }))
          .reverse();
        setSliderImages(formatted);
      } catch (error) {
        console.error('Error fetching slider images:', error.message);
        setSliderImages([]);
      }
    };
    fetchSliderImages();
  }, []);

  /* ---------- Slider Controls ---------- */
  const showNextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % sliderImages.length);
  };
  const showPrevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + sliderImages.length) % sliderImages.length);
  };

  /* Auto-Slide the main hero slider */
  useEffect(() => {
    if (sliderImages.length > 0) {
      const delay = currentSlide === 0 ? 30000 : 7000;
      const autoSlide = setTimeout(() => {
        showNextSlide();
      }, delay);
      return () => clearTimeout(autoSlide);
    }
  }, [currentSlide, sliderImages.length]);

  /* Animate current main slide */
  useEffect(() => {
    if (sliderImages.length > 0) {
      const slides = document.querySelectorAll('.carousel .list .item');
      slides.forEach((slide) => slide.classList.remove('active'));
      if (slides[currentSlide]) slides[currentSlide].classList.add('active');
    }
  }, [currentSlide, sliderImages.length]);

  /* ---------- Initialize Owl for sub-sliders ---------- */
  useEffect(() => {
    import('owl.carousel').then(() => {
      if (newsEvents.length > 1) {
        $('#news-slider').owlCarousel({
          items: 2,
          margin: 10,
          loop: true,
          nav: true,
          navText: [
            '<i class="fas fa-chevron-left"></i>',
            '<i class="fas fa-chevron-right"></i>'
          ],
          autoplay: true,
          autoplayTimeout: 5000,
          autoplayHoverPause: true,
        });
      }
    });
  }, [newsEvents]);

  useEffect(() => {
    import('owl.carousel').then(() => {
      if (admissions.length > 1) {
        $('#admissions-slider').owlCarousel({
          items: 1,
          loop: true,
          nav: true,
          navText: [
            '<i class="fas fa-chevron-left"></i>',
            '<i class="fas fa-chevron-right"></i>'
          ],
          autoplay: true,
          autoplayTimeout: 5000,
          autoplayHoverPause: true,
        });
      }
    });
  }, [admissions]);

  useEffect(() => {
    import('owl.carousel').then(() => {
      if (postgraduateUpdates.length > 1) {
        $('#postgraduate-slider').owlCarousel({
          items: 1,
          margin: 10,
          loop: true,
          nav: true,
          navText: [
            '<i class="fas fa-chevron-left"></i>',
            '<i class="fas fa-chevron-right"></i>'
          ],
          autoplay: true,
          autoplayTimeout: 5000,
          autoplayHoverPause: true,
        });
      }
      if (examinations.length > 1) {
        $('#examinations-slider').owlCarousel({
          items: 1,
          margin: 10,
          loop: true,
          nav: true,
          navText: [
            '<i class="fas fa-chevron-left"></i>',
            '<i class="fas fa-chevron-right"></i>'
          ],
          autoplay: true,
          autoplayTimeout: 5000,
          autoplayHoverPause: true,
        });
      }
    });
  }, [postgraduateUpdates, examinations]);

  useEffect(() => {
    import('owl.carousel').then(() => {
      if (upcomingEvents.length > 1) {
        $('#upcoming-events-slider').owlCarousel({
          items: 1,
          loop: true,
          nav: true,
          navText: [
            '<i class="fas fa-chevron-left"></i>',
            '<i class="fas fa-chevron-right"></i>'
          ],
          autoplay: true,
          autoplayTimeout: 5000,
          autoplayHoverPause: true,
        });
      }
    });
  }, [upcomingEvents]);

  useEffect(() => {
    import('owl.carousel').then(() => {
      if (studentsConsultativeUpdates.length > 1) {
        $('#consultative-slider').owlCarousel('destroy');
        $('#consultative-slider').owlCarousel({
          items: 1,
          loop: true,
          nav: true,
          navText: [
            '<i class="fas fa-chevron-left"></i>',
            '<i class="fas fa-chevron-right"></i>'
          ],
          autoplay: true,
          autoplayTimeout: 5000,
          autoplayHoverPause: true,
        });
      }
    });
  }, [studentsConsultativeUpdates]);

  useEffect(() => {
    import('owl.carousel').then(() => {
      if (tenderNotices.length > 1) {
        $('#tender-notices-slider').owlCarousel({
          items: 1,
          loop: true,
          nav: true,
          navText: [
            '<i class="fas fa-chevron-left"></i>',
            '<i class="fas fa-chevron-right"></i>'
          ],
          autoplay: true,
          autoplayTimeout: 5000,
          autoplayHoverPause: true,
        });
      }
    });
  }, [tenderNotices]);

  useEffect(() => {
    import('owl.carousel').then(() => {
      if (newsAndUpdates.length > 1) {
        $('#news-updates-slider').owlCarousel({
          items: 1,
          loop: true,
          nav: true,
          navText: [
            '<i class="fas fa-chevron-left"></i>',
            '<i class="fas fa-chevron-right"></i>'
          ],
          autoplay: true,
          autoplayTimeout: 5000,
          autoplayHoverPause: true,
        });
      }
    });
  }, [newsAndUpdates]);

  const renderAttachments = (item) => {
    if (!item.attachments) return null;
    let attachArr = [];
    try {
      attachArr = JSON.parse(item.attachments || '[]');
    } catch (e) {
      console.error('Failed to parse attachments for item ID', item.id, e);
      return null;
    }
    if (attachArr.length === 0) return null;
    return (
      <div style={{ marginTop: '5px' }}>
        {attachArr.map((filePath, idx) => (
          <a
            key={idx}
            href={`http://121.52.154.120:3001${filePath}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'block',
              color: '#007bff',
              textDecoration: 'none',
              fontWeight: 'bold',
              marginTop: '4px',
              fontSize: '0.85rem'
            }}
          >
            Download from here
          </a>
        ))}
      </div>
    );
  };

  const ViewAllLink = () => (
    <div className="view-all-container" style={{ textAlign: 'right', marginTop: '10px' }}>
      <a
        href="/all-images"
        className="view-all-link"
        style={{ fontSize: '14px', color: '#007bff', textDecoration: 'none', fontWeight: 'bold' }}
      >
        View All
      </a>
    </div>
  );

  /* ---------- Render Sling Slots (4 Rectangles) ---------- */
  const renderSlingSlots = () => {
    return (
      <div className="sling-slots-container">
        {/* University News and Updates uses non-download logic */}
        <SlingSlot category="University News and Updates" items={newsEvents} useDownload={false} />
        {/* The following three use download logic */}
        <SlingSlot category="Examinations & Results Updates" items={examinations} useDownload={true} />
        <SlingSlot category="Postgraduate Studies & Research Updates" items={postgraduateUpdates} useDownload={true} />
        <SlingSlot category="Admissions and General Circulars" items={newsAndUpdates} useDownload={true} />
      </div>
    );
  };


  return (
    <>
      {/* ============ MAIN SLIDER ============ */}
      <div className="carousel">
        <div className="list">
          {sliderImages.map((image, index) => (
            <div key={image.id} className={`item ${index === currentSlide ? 'active' : ''}`}>
              <img src={image.imageUrl} alt={image.caption} />
              <div className="content">
                <p>QUEST | Nawabshah</p>
                <div className="title">{image.caption}</div>
                <div className="description">{image.detail}</div>
              </div>
            </div>
          ))}
        </div>
        <div className="arrows">
          <button id="prev" onClick={showPrevSlide}></button>
          <button id="next" onClick={showNextSlide}></button>
        </div>

        {/* Sling Slots Overlay at bottom of the slider */}
        <div className="sling-slots-overlay">{renderSlingSlots()}</div>
      </div>

      {/* ============ CONTENT BELOW MAIN SLIDER ============ */}
      <div className="foreground-content">
        <div className="vc-message">
          <ViceChancellorMessage />
        </div>

        {/* ========== 1. University News and Updates ========== */}
        <div className="page-container container">
          <h2 className="consultative-events-heading">University News and Updates</h2>
          <div className="row">
            <div className="col-md-7 featured-news common-card">
              {newsEvents[0] && (
                <>
                  <img
                    className="common-card-image"
                    src={newsEvents[0]?.imageUrl || '/news-images/default.jpg'}
                    alt={newsEvents[0]?.title || 'No Title'}
                  />
                  <div className="card-content">
                    <h3 className="card-title">{newsEvents[0]?.title || 'No Title'}</h3>
                    <p
                      className="card-description two-lines"
                      dangerouslySetInnerHTML={{
                        __html: embedLinkInTruncatedDescription(newsEvents[0]?.description || 'No Description Available')
                      }}
                    />
                    {renderAttachments(newsEvents[0])}
                  </div>
                </>
              )}
            </div>
            <div className="col-md-5">
              <div id="news-slider" className="owl-carousel">
                {newsEvents.slice(1).map((event) => (
                  <div className="common-card" key={event.id}>
                    <img
                      className="common-card-image"
                      src={event.imageUrl || '/news-images/default.jpg'}
                      alt={event.title || 'News Image'}
                    />
                    <div className="card-content">
                      <h4 className="card-title">{event.title || 'No Title'}</h4>
                      <p
                        className="card-description two-lines"
                        dangerouslySetInnerHTML={{
                          __html: embedLinkInTruncatedDescription(event?.description || 'No Description Available')
                        }}
                      />
                      {renderAttachments(event)}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <ViewAllLink />
        </div>

        {/* ========== 2. Research and Innovations (Admissions) ========== */}
        <div className="page-container container">
          <h2 className="consultative-events-heading">Research and Innovations</h2>
          <div className="row">
            <div className="col-md-7 featured-admissions common-card">
              {admissions[0] && (
                <>
                  <img
                    className="common-card-image"
                    src={admissions[0]?.imageUrl || '/admissions/default.jpg'}
                    alt={admissions[0]?.title || 'No Title'}
                  />
                  <div className="card-content">
                    <h3 className="card-title">{admissions[0]?.title || 'No Title'}</h3>
                    <p
                      className="card-description two-lines"
                      dangerouslySetInnerHTML={{
                        __html: embedLinkInTruncatedDescription(admissions[0]?.description || 'No Description Available')
                      }}
                    />
                    {renderAttachments(admissions[0])}
                  </div>
                </>
              )}
            </div>
            <div className="col-md-5 admissions-sliders-container">
              <div id="admissions-slider" className="owl-carousel admissions-slider">
                {admissions.slice(1).map((adm) => (
                  <div className="common-card" key={adm.id}>
                    <img
                      className="common-card-image"
                      src={adm?.imageUrl || '/admissions/default.jpg'}
                      alt={adm.title || 'No Title'}
                    />
                    <div className="card-content">
                      <h5 className="card-title">{adm?.title || 'No Title'}</h5>
                      <p
                        className="card-description two-lines"
                        dangerouslySetInnerHTML={{
                          __html: embedLinkInTruncatedDescription(adm?.description || 'No Description Available')
                        }}
                      />
                      {renderAttachments(adm)}
                    </div>
                  </div>
                ))}
              </div>
              <ViewAllLink />
            </div>
          </div>
        </div>

        {/* ========== 3. Upcoming Events ========== */}
        <div className="page-container container">
          <h2 className="consultative-events-heading">Upcoming Events</h2>
          <div className="row">
            <div className="col-md-7 featured-upcoming-event common-card">
              {upcomingEvents[0] && (
                <>
                  <img
                    className="common-card-image"
                    src={upcomingEvents[0]?.imageUrl || '/events/default.jpg'}
                    alt={upcomingEvents[0]?.title || 'No Title'}
                  />
                  <div className="card-content">
                    <h3 className="card-title">{upcomingEvents[0]?.title || 'No Title'}</h3>
                    <p
                      className="card-description two-lines"
                      dangerouslySetInnerHTML={{
                        __html: embedLinkInTruncatedDescription(upcomingEvents[0]?.description || 'No Description Available')
                      }}
                    />
                  </div>
                </>
              )}
            </div>
            <div className="col-md-5 events-sliders-container">
              <div id="upcoming-events-slider" className="owl-carousel events-slider">
                {upcomingEvents.slice(1).map((evt) => (
                  <div className="common-card" key={evt.id}>
                    <img
                      className="common-card-image"
                      src={evt?.imageUrl || '/events/default.jpg'}
                      alt={evt?.title || 'No Title'}
                    />
                    <div className="card-content">
                      <h5 className="card-title">{evt?.title || 'No Title'}</h5>
                      <p
                        className="card-description two-lines"
                        dangerouslySetInnerHTML={{
                          __html: embedLinkInTruncatedDescription(evt?.description || 'No Description Available')
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <ViewAllLink />
        </div>

        {/* ========== 4. Students' Consultative Bureau Updates ========== */}
        <div className="page-container container">
          <h2 className="consultative-events-heading">Students' Consultative Bureau Updates</h2>
          <div className="row">
            <div className="col-md-7 featured-consultative-event common-card">
              {studentsConsultativeUpdates[0] && (
                <>
                  <img
                    className="common-card-image"
                    src={studentsConsultativeUpdates[0]?.imageUrl || '/consultative/default.jpg'}
                    alt={studentsConsultativeUpdates[0]?.title || 'No Title'}
                  />
                  <div className="card-content">
                    <h3 className="card-title">{studentsConsultativeUpdates[0]?.title || 'No Title'}</h3>
                    <p
                      className="card-description two-lines"
                      dangerouslySetInnerHTML={{
                        __html: embedLinkInTruncatedDescription(studentsConsultativeUpdates[0]?.description || 'No Description Available')
                      }}
                    />
                  </div>
                </>
              )}
            </div>
            <div className="col-md-5 consultative-sliders-container">
              <div id="consultative-slider" className="owl-carousel consultative-slider">
                {studentsConsultativeUpdates.slice(1).map((update) => (
                  <div className="common-card" key={update.id}>
                    <img
                      className="common-card-image"
                      src={update?.imageUrl || '/consultative/default.jpg'}
                      alt={update.title || 'No Title'}
                    />
                    <div className="card-content">
                      <h5 className="card-title">{update?.title || 'No Title'}</h5>
                      <p
                        className="card-description two-lines"
                        dangerouslySetInnerHTML={{
                          __html: embedLinkInTruncatedDescription(update?.description || 'No Description Available')
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <ViewAllLink />
        </div>

        {/* ========== 5. Student Events and Sports ========== */}
        <div className="page-container container">
          <h2 className="consultative-events-heading">Student Events and Sports</h2>
          <div className="row">
            <div className="col-md-7 featured-student-events common-card">
              {studentEvents[0] && (
                <>
                  <img
                    className="common-card-image"
                    src={studentEvents[0]?.imageUrl || '/student-events/default.jpg'}
                    alt={studentEvents[0]?.title || 'No Title'}
                  />
                  <div className="card-content">
                    <h3 className="card-title">{studentEvents[0]?.title || 'No Title'}</h3>
                    <p
                      className="card-description two-lines"
                      dangerouslySetInnerHTML={{
                        __html: embedLinkInTruncatedDescription(studentEvents[0]?.description || 'No Description Available')
                      }}
                    />
                    {renderAttachments(studentEvents[0])}
                  </div>
                </>
              )}
            </div>
            <div className="col-md-5 student-events-sliders-container">
              <div id="student-events-slider" className="owl-carousel student-events-slider">
                {studentEvents.slice(1).map((evt) => (
                  <div className="common-card" key={evt.id}>
                    <img
                      className="common-card-image"
                      src={evt?.imageUrl || '/student-events/default.jpg'}
                      alt={evt?.title || 'No Title'}
                    />
                    <div className="card-content">
                      <h5 className="card-title">{evt?.title || 'No Title'}</h5>
                      <p
                        className="card-description two-lines"
                        dangerouslySetInnerHTML={{
                          __html: embedLinkInTruncatedDescription(evt?.description || 'No Description Available')
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
              <ViewAllLink />
            </div>
          </div>
        </div>

        {/* ========== 6. Exams & Postgraduate ========== */}
        <div className="page-container container">
          <div className="row">
            <div className="col-md-6">
              <div className="featured-examinations common-card" style={{ height: 'auto' }}>
                <h2 className="consultative-events-heading" style={{ marginTop: 0 }}>
                  Examinations & Results Updates
                </h2>
                {examinations.slice(0, 3).map((exam) => (
                  <div className="card-subitem" key={exam.id}>
                    <h4 className="card-title">{exam.title}</h4>
                    <p
                      className="card-description two-lines"
                      dangerouslySetInnerHTML={{
                        __html: embedLinksWithDownloadOption(exam.description || 'No Description Available')
                      }}
                    />
                    {renderAttachments(exam)}
                  </div>
                ))}
                <div id="examinations-slider" className="owl-carousel examinations-slider">
                  {examinations.map((exam, idx) => (
                    <div className="card-subitem" key={`exam-slider-${idx}`}>
                      <h4 className="card-title">{exam.title}</h4>
                      <p
                        className="card-description two-lines"
                        dangerouslySetInnerHTML={{
                          __html: embedLinksWithDownloadOption(exam.description || 'No Description Available')
                        }}
                      />
                      {renderAttachments(exam)}
                    </div>
                  ))}
                </div>
              </div>
              <ViewAllLink />
            </div>

            <div className="col-md-6">
              <div className="featured-postgraduate common-card" style={{ height: 'auto' }}>
                <h2 className="consultative-events-heading" style={{ marginTop: 0 }}>
                  Postgraduate Studies & Research Updates
                </h2>
                {postgraduateUpdates.slice(0, 3).map((upd) => (
                  <div className="card-subitem" key={upd.id}>
                    <h4 className="card-title">{upd.title}</h4>
                    <p
                      className="card-description two-lines"
                      dangerouslySetInnerHTML={{
                        __html: embedLinksWithDownloadOption(upd.description || 'No Description Available')
                      }}
                    />
                    {renderAttachments(upd)}
                  </div>
                ))}
                <div id="postgraduate-slider" className="owl-carousel updates-slider">
                  {postgraduateUpdates.map((upd, idx) => (
                    <div className="card-subitem" key={`postgrad-slider-${idx}`}>
                      <h4 className="card-title">{upd.title}</h4>
                      <p
                        className="card-description two-lines"
                        dangerouslySetInnerHTML={{
                          __html: embedLinksWithDownloadOption(upd.description || 'No Description Available')
                        }}
                      />
                      {renderAttachments(upd)}
                    </div>
                  ))}
                </div>
              </div>
              <ViewAllLink />
            </div>
          </div>
        </div>

        {/* ========== 7. Tender Notices & Admissions/General Circulars ========== */}
        <div className="page-container container">
          <div className="row">
            <div className="col-md-6">
              <h2 className="consultative-events-heading" style={{ marginTop: 0 }}>
                Tender Notices
              </h2>
              <div className="featured-tenders common-card" style={{ height: 'auto' }}>
                {tenderNotices.slice(0, 3).map((tn) => (
                  <div className="card-subitem" key={tn.id}>
                    <h4 className="card-title">{tn.title}</h4>
                    <p
                      className="card-description two-lines"
                      dangerouslySetInnerHTML={{
                        __html: embedLinksWithDownloadOption(tn.description || 'No Description Available')
                      }}
                    />
                    {renderAttachments(tn)}
                  </div>
                ))}
                <div id="tender-notices-slider" className="owl-carousel tenders-slider">
                  {tenderNotices.map((tn, idx) => (
                    <div className="card-subitem" key={`tender-slider-${idx}`}>
                      <h4 className="card-title">{tn.title}</h4>
                      <p
                        className="card-description two-lines"
                        dangerouslySetInnerHTML={{
                          __html: embedLinksWithDownloadOption(tn.description || 'No Description Available')
                        }}
                      />
                      {renderAttachments(tn)}
                    </div>
                  ))}
                </div>
              </div>
              <ViewAllLink />
            </div>
            <div className="col-md-6">
              <h2 className="consultative-events-heading" style={{ marginTop: 0 }}>
                Admissions and General Circulars
              </h2>
              <div className="featured-news-updates common-card" style={{ height: 'auto' }}>
                {newsAndUpdates.slice(0, 3).map((news) => (
                  <div className="card-subitem" key={news.id}>
                    <h4 className="card-title">{news.title}</h4>
                    <p
                      className="card-description two-lines"
                      dangerouslySetInnerHTML={{
                        __html: embedLinksWithDownloadOption(news.description || 'No Description Available')
                      }}
                    />
                    {renderAttachments(news)}
                  </div>
                ))}
                <div id="news-updates-slider" className="owl-carousel news-slider">
                  {newsAndUpdates.map((nws, idx) => (
                    <div className="card-subitem" key={`news-slider-${idx}`}>
                      <h4 className="card-title">{nws.title}</h4>
                      <p
                        className="card-description two-lines"
                        dangerouslySetInnerHTML={{
                          __html: embedLinksWithDownloadOption(nws.description || 'No Description Available')
                        }}
                      />
                      {renderAttachments(nws)}
                    </div>
                  ))}
                </div>
              </div>
              <ViewAllLink />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Home;
